module.exports = __webpack_public_path__ + "img/bg2.d043a9cc.png";